import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function GetQR({
  color = 'icon.arrowBlue',
  strokeWidth = '1.5',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 20 20' {...props}>
      <Path
        d='M4.50411 6.00391V10.0056'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M8.17208 6.00391V10.0056'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M11.8401 6.00391V10.0056'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M5.00167 19.0095H4.00125C2.34371 19.0095 1 17.6658 1 16.0082V15.0078'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M15.0078 1H16.0082C17.6658 1 19.0095 2.34371 19.0095 4.00125V5.00167'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M1 5.00167V4.00125C1 2.34371 2.34371 1 4.00125 1H5.00167'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M19.0095 15.0078V16.0082C19.0095 17.6658 17.6658 19.0095 16.0082 19.0095H15.0078'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M4.50411 13.0078V15.0087'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M8.17208 13.0078V15.0087'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M11.8401 13.1328V15.0086'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M15.508 13.1328V15.0086'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M15.508 6.00391V10.0056'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M2 10.0041H18.0067'
        stroke={color}
        strokeWidth={strokeWidth}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

GetQR.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.string,
  fill: PropTypes.string,
}

export default GetQR
